import React, { CSSProperties, memo } from 'react';
import { areEqual } from 'react-window';

import { virtualizedListConfig } from './virtualizedListConfig';
import { ListRowMenuItemProps } from '../types';

type ListItemsRowRendererProps = {
  data: ListRowMenuItemProps[];
  index: number;
  style: CSSProperties;
};

const VirtualizedListRowRenderer = ({ data, index: rowIndex, style }: ListItemsRowRendererProps) => {
  const row = data[rowIndex];
  const Component = virtualizedListConfig[row.type].component;
  if (!row || !Component) {
    return null;
  }

  return <Component {...row} style={style} />;
};

export default memo(VirtualizedListRowRenderer, areEqual);
